import styled from "styled-components";
import { Dark2 } from "../../Constants/ColorChart";

export const PlaylistsViewItem = styled.div`
    ${ props => props.seeAllPlaylist && `display: inline-grid; margin-top: 10px;` }
	transition: all 300ms;
    width: 175px;
    height: 200px;
    margin-right: 40px;
    box-sizing: content-box;
    z-index: 1;
    position: relative;
    text-align: left;
    padding: 15px;
    background: ${ props => props.background };

    @media (min-width: 992px){
        width: 250px;
        height: 300px;
    }
    &:hover{
        opacity: 0.8;
        cursor: pointer;
    }
`;

export const PlaylistsViewItemType = styled.p`
    font-size: 15px;
    color: ${ props => props.color };
`;
export const Title = styled.div`
    color: ${ props => props.color };
    font-size: 16px;
    @media (min-width: 992px){
        font-size: 25px
    }
`;
export const PlaylistsViewItemData = styled.p`
    color: ${ Dark2 }
    position: absolute;
    bottom: 2px;
    margin-bottom: 0.5rem
`;
